(function(){
  'use strict';

  angular
    .module('checker.filters')
    .filter('searchDrugs', searchDrugs);

  function removeAccents(value) {
    return value
        .replace(/[áÁ]/g, 'a')
        .replace(/[éÉ]/g, 'e')
        .replace(/[íÍ]/g, 'i')
        .replace(/[óÓ]/g, 'o')
        .replace(/[úÚ]/g, 'u');
  }

  function searchDrugs(){
    return function (items, query) {
      if (!items || !items.length) return;
      var filtered = [];
      var letterMatch = new RegExp(query, 'i');
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (query) {
          if (letterMatch.test(removeAccents(item.display_name.toLowerCase()))) {
            filtered.push(item);
          } else if (item.drug_trade_names && matchTradeNames(letterMatch, item.drug_trade_names)) {
            filtered.push(item);
          }
        } else {
          filtered.push(item);
        }
      }
      return filtered;
    };
  }

  function matchTradeNames(letterMatch, tradeNames) {
    for (var i = 0; i < tradeNames.length; i++) {
      var tradeName = tradeNames[i];
      if (letterMatch.test(removeAccents(tradeName.toLowerCase()))) {
        return true;
      }
    }
    return false;
  }

})();
